import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useContext } from "react";
import AddCardForm from "./add-card-form";
import ConfirmPayment from "./confirm-Payment";
import { SpinnerContext } from "../../components/spinner/spinner.component";

const stripePromise = loadStripe(
  "pk_live_BY7gzvL3sojUr4kryHW6Wdc000J0xMcESm"
);
function AddCard(props) {
  const context = useContext(SpinnerContext);
  const setPageName = (childData) => {
    context.setsubscribePage(childData);
  };

  return (
    <Elements stripe={stripePromise}>
      {props.paymentPlan === "PaymentConfirmation" ? (
        <ConfirmPayment
          clientSecret={props.clientSecret}
          childCallback={props.parentCallback}
          {...props}
          allDetails={props}
          parentCallback={setPageName}
        />
      ) : (
        <AddCardForm {...props} />
      )}
    </Elements>
  );
}

export default AddCard;
